import { render, staticRenderFns } from "./nav-tab-menu.vue?vue&type=template&id=d90108c8&scoped=true&"
import script from "./nav-tab-menu.vue?vue&type=script&lang=js&"
export * from "./nav-tab-menu.vue?vue&type=script&lang=js&"
import style0 from "./nav-tab-menu.vue?vue&type=style&index=0&id=d90108c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90108c8",
  null
  
)

export default component.exports